import { render } from "./laboratory.vue?vue&type=template&id=e21387de&scoped=true"
import script from "./laboratory.vue?vue&type=script&lang=js"
export * from "./laboratory.vue?vue&type=script&lang=js"

import "./laboratory.vue?vue&type=style&index=0&id=e21387de&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e21387de"]])

export default __exports__